module.exports = __webpack_public_path__ + "media/images/riders/ANNIKA_LANGVAD-1873f5446c85a3440dcc6ba4033bd61d.png";